/**
 * Footer Constants
 * Company name and footer links
 */

export const COMPANY_NAME = "VisitPro";

export const FOOTER_LINKS = {
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",
  PUBLIC_OFFER: "/public-offer",
  WEBSITE_NAME: "onvisit.pro",
} as const;
